export default __webpack_public_path__ + "97b1a8c7c85abc918cdca9c50d1f8f64.navmesh";